import { createSelector } from 'reselect';
import _map from 'lodash/map';

import { getEntity } from 'store/services/entities/selectors';

export const getEntitiesDictionariesList = ({ entitiesDictionaries }) =>
  entitiesDictionaries.list.data.items;

export const getEntitiesDictionaries = ({ entitiesDictionaries }) =>
  entitiesDictionaries.list.data.items;

export const getEntitiesDictionariesCount = ({ entitiesDictionaries }) =>
  entitiesDictionaries.list.data.count;

export const getIsLoading = ({ entitiesDictionaries }) =>
  entitiesDictionaries.list.isLoading;

export const gatherDictionariesConnectedIds = createSelector(getEntity, item =>
  _map(item.dictionary_connections, dictionary => dictionary.dictionary).join(
    ',',
  ),
);
